import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SECTIONS, reportActions } from '../../../store/reportStore'
import { withLocalize } from 'react-localize-redux';
import { Translate } from 'react-localize-redux';
import classnames from 'classnames';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Paging from '../../common/pagingComponent';
import RelationLink from './relationLink';
import GreenSemaphore from '../../../img/icons/GreenSemafor';
import YellowSemaphore from '../../../img/icons/YellowSemafor';
import RedSemaphore from '../../../img/icons/RedSemafor';
import ExcelExportButton from '../../common/excelExportButton';
import { Link } from "react-router-dom";
import { apiGet, processErrorMessage } from '../../../store/apiWrapper';

class RelationSubSection extends React.Component {
    state = {
        historyExpanded: false,
        expandMap: {},
        shouldExpandMap: {},
        page: 1,
        totalCount: null,
        loadingTotal: false
    };
    dataRefMap = {};

    get section() {
        var section = this.props.sections.find(o => o.id === this.props.sectionId)
        return section.subsections.find(q => q.id === this.props.subsectionId) || section;
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.subsectionId || this.props.sectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated)
            this.setState({ isHistoryExpandedTouched: false });

        const data = this.section.data;

        if (data) {

            var prevActual = null;
            var prevHistorical = null;
            var prevAddresses = null;

            if (this.prevProps) {
                const prevSection = this.prevProps.sections.find(o => o.id === this.prevProps.sectionId);
                if (prevSection) {
                    var prevSubsection = prevSection.subsections.find(q => q.id === this.prevProps.subsectionId);
                    if (prevSubsection) {
                        var prevData = prevSubsection.data;
                        if (prevData) {
                            prevActual = prevData.relationsActual;
                            prevHistorical = prevData.relationsHistorical;
                            prevAddresses = prevData.addresses;
                        }
                    }
                }
            }

            // run resize only if needed
            if (((prevActual === null || prevActual === undefined) && (data.relationsActual !== null && data.relationsActual !== undefined)) ||
                ((prevHistorical === null || prevHistorical === undefined) && (data.relationsHistorical !== null && data.relationsHistorical !== undefined)) ||
                ((prevAddresses === null || prevAddresses === undefined) && (data.addresses !== null && data.addresses !== undefined)) ||
                ((prevActual || []).length !== (data.relationsActual || []).length) || ((prevHistorical || []).length !== (data.relationsHistorical || []).length) ||
                ((prevAddresses || []).length !== (data.addresses || []).length) ||
                prevState.historyExpanded !== this.state.historyExpanded) {
                this._debounce = window.setTimeout(() => this.updateSize(), 250);
            }
        }
    }

    componentDidMount() {
        this.test = window.addEventListener('resize', this.onResize, false)
        this.updateSize();
        if (!this.props.subsectionId && this.state.totalCount === null && !this.state.loadingTotal)
            this.getTotalCount();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false)
    }

    updateSize = () => {
        this._debounce = undefined;
        if (this.dataRefMap === null || this.dataRefMap === undefined || Object.keys(this.dataRefMap).length === 0) {
            return;
        }
        let shouldExpandMap = { ...this.state.shouldExpandMap };
        let runSetState = false;
        const keys = Object.keys(this.dataRefMap);
        for (let idx = 0; idx < keys.length; idx++) {
            const se = this.dataRefMap[keys[idx]].offsetWidth < this.dataRefMap[keys[idx]].scrollWidth;
            if (shouldExpandMap[keys[idx]] !== se && !this.state.expandMap[keys[idx]]) {
                shouldExpandMap[keys[idx]] = se;
                runSetState = true;
            }
        }
        if (runSetState) {
            this.setState({ shouldExpandMap });
        }
    }

    onResize = e => {
        if (this._debounce !== null && this._debounce !== undefined) {
            window.clearTimeout(this._debounce);
        }
        this._debounce = window.setTimeout(() => this.updateSize(), 250);
    }

    render() {
        if (this.section.name === undefined || this.section.name === null)
            return null;

        const { data, loadingMoreData, isLimited } = this.section;
        if (isNullOrUndefined(data))
            return null;

        var totalCount = 0;
        if (this.props.subsectionId)
            totalCount = this.props.getParentSection([this.props.sectionId, this.props.subsectionId]).data.sectionCounts.find(f => f.sectionId === this.props.subsectionData.type).count;
        else if (this.state.totalCount !== null)
            totalCount = this.state.totalCount;

        const max = totalCount > this.pageSize * this.state.page ? this.pageSize * this.state.page : totalCount;

        const isRelatedAddress = !this.props.subsectionId || this.props.subsectionData.type === "NRSA";
        const isOwnerRelationId = this.props.subsectionId && (this.props.subsectionData.type === "NR03_R" || this.props.subsectionData.type === "NR03_I");
        const isNrBO = this.section.id === `${SECTIONS.relationItems}_NRBO` || this.section.id === `${SECTIONS.relationItems}_All`;
        const columnCount = isNrBO ? 9 : 8;

        return (
            <>
                {isRelatedAddress ?
                    <>
                        <div style={{ height: '1em', padding: '0' }} />
                        <OldStyleTableWithHistory offsetLeft={false} offsetLeftHalf={true} isLimited={isLimited}
                            head={this.renderHeadAddress} tableColumns={4} stripped classNames='related-addresses'
                            actualData={data.addresses} actualRow={a => this.renderAddress(a)}
                            resolveExpanded={this.props.resolveExpanded} noMargin={!this.props.subsectionId}
                        />
                    </>
                    :
                    <OldStyleTableWithHistory offsetLeft={false} isLimited={isLimited} classNames='related-addresses'
                        head={() => this.renderHead(isOwnerRelationId, isNrBO)} tableColumns={columnCount} onHistoryToggle={this.onHistoryToggle} stripped
                        actualData={data.relationsActual} actualRow={(r) => this.renderRelationRow(r, false, isOwnerRelationId, isNrBO)}
                        historyData={data.relationsHistorical} historyRow={(r) => this.renderRelationRow(r, true, isOwnerRelationId, isNrBO)}
                        resolveExpanded={this.props.resolveExpanded}
                    />
                }
                {isLimited && totalCount > max && this.renderMoreLinks(totalCount, loadingMoreData, isRelatedAddress)}
                {!isLimited && totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
                {this.state.loadingTotal && <div style={{ width: "100%", fontSize: "0.1em" }} className="search-progress searching" />}
                {isRelatedAddress && <ExcelExportButton link="related-addresses" entityId={this.props.id} report={this.props.reportType} />}
            </>
        )
    }

    getTotalCount = () => {
        this.setState({ loadingTotal: true });
        apiGet(`${window.babylonApiUrl}/api/report/${this.props.id}/relations-addresses-count`, null,
            res => {
                if (res.error) {
                    this.props.raiseSectionError([this.props.sectionId], processErrorMessage(res.error, "UnhappyUser.SectionError"));
                } else {
                    this.setState({ totalCount: res.data, loadingTotal: false });
                }
            },
            err => {
                this.props.raiseSectionError([this.props.sectionId], processErrorMessage(err, "UnhappyUser.SectionError"));
            }
        );
    }

    onHistoryToggle = (historyExpanded) => {
        this.setState({ historyExpanded })
    }

    renderHeadAddress = () => {
        return (
            <thead>
                <tr>
                    <th rowSpan={2}><Translate id="Report.Relations.Address" /></th>
                    <th rowSpan={2} style={{ width: '22%' }}><Translate id="Report.Relations.Address.Type" /></th>
                    <th colSpan="2" style={{ width: '22%', textAlign: 'center' }}>
                        <Translate id="Report.Relations.Address.Subjects" />
                    </th>
                    <th rowSpan={2} style={{ width: '17%' }}><Translate id="Report.Common.Source" /></th>
                </tr>
                <tr>
                    <th style={{ textAlign: 'center' }}><Translate id="Common.Actual" /></th>
                    <th style={{ textAlign: 'center' }}><Translate id="Common.Historical" /></th>
                </tr>
            </thead>
        );
    }

    renderAddress = (data) => {
        if (data === undefined || data === null)
            return null;

        return (
            <tr key={data.entityId} className='colorize'>
                <td><Link className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal' })} to={{ pathname: `/related-address/${this.props.id}/${data.entityId}` }} target="_blank">{data.fullAddress}</Link></td>
                <td>{data.type}</td>
                <td style={{ textAlign: 'center' }}>{data.actualCount}</td>
                <td style={{ textAlign: 'center' }}>{data.historicalCount}</td>
                <td>{data.source}</td>
            </tr>
        );
    }

    renderHead = (ownerRelations, isNrBO) => {
        return (
            <thead className="relations-header">
                <tr>
                    <th className="col-semaphore" />
                    <th><Translate id="Report.Relations.EntityName" /></th>
                    <th className="col-identification"><Translate id="Report.Relations.EntityIdentification" /></th>
                    <th><Translate id="Report.Relations.Position" /></th>
                    {(ownerRelations || isNrBO) ? <th className="col-share">{ownerRelations ? <Translate id="Report.Relations.ShareDeposit" /> : <Translate id="Report.Relations.BenefitShare" />}</th> : <th className="col-share"></th>}
                    {/* <th><Translate id="Report.Relations.WarningInfo" /></th> */}
                    <th className="col-date" style={{ textAlign: 'right' }}><Translate id="Report.Common.ValidFrom" /></th>
                    <th className="col-date" style={{ textAlign: 'right' }}><Translate id="Report.Common.ValidTo" /></th>
                    <th className="col-country"><Translate id="Report.Relations.Country" /></th>
                    {isNrBO && <th className="col-source"><Translate id="Report.Common.Source" /></th>}
                </tr>
            </thead>
        );
    }

    renderRelationRow = (r, isHistory, ownerRelations, isNrBO) => {
        return (
            <tr key={r.id} className={classnames('relations-row', 'colorize', { 'old-style-table-report-history-row': isHistory })}>
                {this.renderSemaphore(r.semaphoreCode) !== null ? <td className="semaphore-td col-semaphore">{this.renderSemaphore(r.semaphoreCode)}</td> : <td className="col-semaphore"></td>}
                <td><RelationLink wrap entityName={(r.prefix != null ? (r.prefix + ' ') : '') + r.name + (r.suffix != null ? (' ' + r.suffix) : '')} entityId={r.entityId} reports={r.reports} customPrefix={<></>} showOnMobile={true} /></td>
                <td className="col-identification">{this.renderEntityIdentification(r)}</td>
                <td colSpan={!ownerRelations && !isNrBO ? 2 : 1}>{isNullOrUndefined(r.function) ? r.position : r.position + " - " + r.function}</td>
                {(ownerRelations || isNrBO) && <td className="col-share" style={{ display: "table-cell", overflowWrap: 'break-word', wordWrap: 'break-word' }}>{ownerRelations ? this.renderOwnerShare(r) : r.shareFormated}</td>}
                {/* <td>{this.renderWarnings(r.warnings)}</td> */}
                <td className="col-date" style={{ textAlign: 'right' }}>{r.startDateFormated}</td>
                <td className="col-date" style={{ textAlign: 'right' }}>{r.endDateFormated}</td>
                <td className="col-country" title={r.country}>{r.countryCode}</td>
                {isNrBO && <td className="col-source" title={r.sourceDescription}>{r.sourceShortening}</td>}
            </tr>
        );
    }

    renderSemaphore = (code) => {
        if (code === undefined || code === null)
            return null;

        if (code === 1)
            return <div><GreenSemaphore /></div>
        else if (code === 2)
            return <div><YellowSemaphore /></div>
        else if (code === 3)
            return <div><RedSemaphore /></div>

        return null;
    }

    renderEntityIdentification = (entity) => {
        if (entity === undefined || entity === null)
            return null;

        if (entity.birthDateFormated !== undefined && entity.birthDateFormated !== null)
            return entity.birthDateFormated;
        else
            return entity.companyId;
    }

    renderOwnerShare = (entity) => {
        if (entity === undefined || entity === null)
            return null;

        if (entity.share === null && entity.depositValue === null)
            return null;

        return (
            <React.Fragment>
                <span style={{ whiteSpace: "nowrap", display: "inline-flex" }}>{entity.shareFormated}<span className="l-padded r-padded">/</span></span>
                <span style={{ whiteSpace: "nowrap", display: "inline-flex" }}>{entity.depositValueFormated}&nbsp;</span>
                <span>
                    {entity.currencyUnit === 1000 && <><Translate id="Report.Common.CurrencyThousands" /><span className="l-padded" /></>}
                    {entity.currency}
                </span>
            </React.Fragment>
        );
    }

    getMore = () => {
        this.props.fetchMoreData(
            this.props.subsectionId ? [this.props.sectionId, this.props.subsectionId] : [this.props.sectionId],
            { count: this.pageSize, offset: this.pageSize, report: this.props.reportType, type: this.props.subsectionData.type, withHistory: true },
            null, this.concatData, () => this.setState({ page: 2 })
        );
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            this.props.subsectionId ? [this.props.sectionId, this.props.subsectionId] : [this.props.sectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType, type: this.props.subsectionId ? this.props.subsectionData.type : 'NRSA', withHistory: true },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    renderMoreLinks = (totalCount, isLoading, isRelatedAddress) => {
        return (
            <>
                <div style={{ paddingBottom: isRelatedAddress ? '1em' : null }}>
                    {this.state.page === 1 && <span className="link-functional" onClick={() => this.getMore()}>
                        <Translate id="Report.Common.More" />
                    </span>}
                    {this.state.page === 2 && <a className="link-functional" target="_blank"
                        href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, isRelatedAddress ? SECTIONS.relatedAddresses : this.props.sectionId)}
                    >
                        <Translate id="Report.Common.ShowAll" />
                        {!isRelatedAddress && <>&nbsp;({totalCount})</>}
                    </a>}
                </div>
                {isLoading && <div style={{ width: "100%", paddingBottom: '0', paddingTop: '0' }} className="search-progress searching"></div>}
            </>
        )
    }

    concatData = (_hint, oldData, newData) => {
        if (!isNullOrUndefined(oldData.relationsActual))
            oldData.relationsActual = oldData.relationsActual.concat(newData.relationsActual);
        if (!isNullOrUndefined(oldData.relationsHistorical))
            oldData.relationsHistorical = oldData.relationsHistorical.concat(newData.relationsHistorical);
        if (!isNullOrUndefined(oldData.addresses))
            oldData.addresses = oldData.addresses.concat(newData.addresses);
        return oldData;
    }

    replaceData = (_hint, _oldData, data) => data;

    showLess = (id) => {
        let expandMap = { ...this.state.expandMap };
        expandMap[id] = !expandMap[id];
        this.setState({ expandMap });
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(RelationSubSection));